import {DlSelectOption, utils} from '@wallaby-ui/core';
import {sortBy} from 'lodash';
import React, {useMemo} from 'react';
import {useIntl} from 'react-intl';
import {Options} from 'react-select';

import {
  FilterNodeTypeSelectContainer,
  FilterNodeTypeSelectOwnProps,
} from './FilterNodeTypeSelectContainer';
import {getSelectOptionIdProperty} from '../filtering_helpers';
import {AGENS_REDUCER_STATE_ID} from 'src/js/containers/agens/agens_constants';
import {useAppSelector} from 'src/js/store_hooks';

interface OwnProps extends Omit<FilterNodeTypeSelectOwnProps, 'data'> {
  isMui?: boolean;
}

type Props = OwnProps;

export const FilterNodeTypeAgens: React.FC<Props> = (props) => {
  const {isMui} = props;
  const agens = useAppSelector(
    (state) => state[AGENS_REDUCER_STATE_ID].filterData
  );
  const intl = useIntl();

  const options = useMemo<Options<DlSelectOption>>(() => {
    const idProperty = getSelectOptionIdProperty(isMui);
    return sortBy(
      agens.map((item) => {
        const translatedLabel = utils.TranslateUtils.translate(
          item.label,
          intl
        );
        return {
          [idProperty]: item.id.toString(),
          label: translatedLabel,
        };
      }),
      'label'
    );
  }, [agens, intl, isMui]);

  return <FilterNodeTypeSelectContainer {...props} options={options} />;
};

FilterNodeTypeAgens.displayName = 'FilterNodeTypeAgens';
